import { motion } from "framer-motion";
import { ITINERARY } from "../../data";
import { fadeUp, viewportOnce } from "../../lib/motion";

export const Itinerary = () => (
  <section id="itinerario" data-testid="itinerary" className="relative bg-ink-2 py-24 sm:py-32 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-10 sm:mb-14">
        <div>
          <div className="overline mb-6">Itinerario · Espera lo inesperado</div>
          <h2 className="font-display font-light text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
            Prepárate para <em className="italic text-ember">lo inesperado</em>
          </h2>
        </div>
        <p className="font-body font-light text-sm text-[var(--muted)] max-w-xs leading-relaxed">
          Esto no es un viaje relajado. Exprimimos cada segundo y el itinerario
          se adapta a lo que Islandia nos regale ese día.
        </p>
      </motion.div>

      <motion.p
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="font-display font-light text-2xl sm:text-4xl lg:text-5xl leading-snug tracking-tight max-w-4xl mb-16 sm:mb-24 text-[var(--paper)]/90"
      >
        Si hay que caminar en mitad de la noche para vivir una experiencia
        secreta, <em className="italic text-ember">lo haremos</em>. Solo pedimos una cosa:
        mente abierta y dejarse llevar.
      </motion.p>

      <div className="flex flex-col gap-16 sm:gap-24">
        {ITINERARY.map((d, i) => (
          <motion.div
            key={d.day}
            data-testid={`itinerary-day-${i + 1}`}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center ${
              i % 2 === 1 ? "lg:[direction:rtl]" : ""
            }`}
          >
            <div className="lg:col-span-6 [direction:ltr]">
              <div className="relative overflow-hidden group">
                <img
                  src={d.img}
                  alt={d.title}
                  className="w-full h-[320px] sm:h-[460px] object-cover transition-transform duration-1000 ease-out group-hover:scale-105 grayscale-[0.2] group-hover:grayscale-0"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
              </div>
            </div>
            <div className="lg:col-span-6 [direction:ltr] lg:px-6">
              <span className="font-body text-glacier text-xs uppercase tracking-[0.3em] font-semibold">
                {d.day}
              </span>
              <h3 className="mt-4 font-display font-light text-3xl sm:text-5xl leading-tight">{d.title}</h3>
              <p className="mt-6 font-body font-light text-base text-[var(--muted)] leading-relaxed max-w-md">
                {d.text}
              </p>
              <p className="mt-6 font-display italic text-lg text-[var(--paper)]/50">
                Noche — tiempo de sueño, sueños y auroras.
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
